<template>
  <div v-if="loading" class="loading-container">
    <b-spinner label="Loading..." variant="dark" />
  </div>
  <b-container v-else>
    <b-row class="m-0">
      <b-col v-if="!loading" class="container__submit-evidence p-0">
        <div
          class="d-flex justify-content-start align-items-center"
          :class="{ 'my-2': isLargeScreen }"
        >
          <div v-if="!isLargeScreen" class="mr-2">
            <EvidenceSidebar
              ref="evidenceSidebar"
              class="side-bar__create-method pl-0"
              :class="{ 'my-3': !isLargeScreen }"
            >
              <EvidenceNavigator
                ref="evidenceNavigator"
                class="navigator sticky"
                :class="{ 'mobile-navigator': !isLargeScreen }"
                :parts="partPostIds"
                :part-meta-data="partMetaData"
                :selected-post-id="selectedPostId"
                :finished-posts="finishedPost"
                :not-passed-posts="notPassedPosts"
                :is-show-continue-button="isShowContinueButton"
                :is-continueable="isContinueable"
                :is-submitting="saving"
                :count-remaining-submission="countRemainingSubmission"
                :count-total-submission="countTotalSubmission"
                @navigation-clicked="isShowNavigator = false"
                @post-selected="onPostSelected"
                @change-item="onNavigationChangeItem"
                @continue="onContinue"
              />
            </EvidenceSidebar>
          </div>
          <div>
            <b-button
              ref="btn__previous-page"
              variant="link"
              class="btn__previous-page p-0"
              :class="{ 'pl-0': isLargeScreen, 'my-3': isLargeScreen }"
              @click="backToMethodComponents"
            >
              <font-awesome-icon icon="chevron-left" class="mr-u1" />
              <span> Back to method components </span>
            </b-button>
          </div>
          <div v-if="evidenceSubmission && evidenceSubmission.isAwarded && credential" class="mb-4">
            <modal-congratulation
              :show="credential.seen_at === null ? true : false"
              :accredible-link="credential.accredible_credential.url"
              :credential-id="credential.id"
            />

            <post-certificate
              :certificate-image-link="learningUnit.badge_image[0].url"
              :accredible-link="credential.accredible_credential.url"
              :user="credential.user"
              :date="new Date(credential.accredible_credential.issued_on)"
            />
          </div>
        </div>

        <evidence-submission-user-status-v2
          v-if="user && selectedEvidenceSubmissionId"
          v-model="selectedEvidenceSubmissionId"
          :user="user"
          :learning-unit="learningUnit"
          :assessor-recommendation="evidenceSubmission.assessor_recommendation"
          view="learner"
          class="mb-4 w-100"
          @change="onSelectedEvidenceSubmissionIdChanged"
        />

        <b-form id="formSubmitEvidence">
          <!-- <post-evaluation-assessment-part
            v-for="(partMeta, index) in partMetaData"
            ref="card__part-task-list"
            :key="`card__part-${index + 1}-task-list`"
            class="mb-3"
            :part="partMeta"
            :learning-unit="learningUnit"
            :post-ids="partPostIds[partMeta] ? partPostIds[partMeta] : []"
            :editable="false"
            submittable
            :visible-status-submittable="visibleStatus"
            :assessable="evidenceSubmission.isAwarded || evidenceSubmission.isDenied"
            :disabled="submitting"
            :evidence-submission="evidenceSubmission"
          >
          </post-evaluation-assessment-part> -->

          <!-- v-for="(partMeta, index) in partMetaData" -->
          <b-row>
            <b-col v-if="isLargeScreen" cols="4">
              <EvidenceNavigator
                ref="evidenceNavigatorLarge"
                class="navigator sticky"
                :class="{ 'mobile-navigator': !isLargeScreen }"
                :parts="partPostIds"
                :part-meta-data="partMetaData"
                :selected-post-id="selectedPostId"
                :finished-posts="finishedPost"
                :not-passed-posts="notPassedPosts"
                :is-show-continue-button="isShowContinueButton"
                :is-continueable="isContinueable"
                :is-submitting="saving"
                :count-remaining-submission="countRemainingSubmission"
                :count-total-submission="countTotalSubmission"
                @navigation-clicked="isShowNavigator = false"
                @post-selected="onPostSelected"
                @change-item="onNavigationChangeItem"
                @continue="onContinue"
              />
            </b-col>
            <b-col>
              <!-- Create new submission button section -->
              <CreateNewSubmissionCard
                v-show="canCreateNewSubmission"
                :learning-unit-id="learningUnitId"
                :user-id="userId"
                @submission-created="onSubmissionCreated"
              />
              <learning-unit-score-description-card
                v-if="learningUnit.score_description"
                :learning-unit="learningUnit"
                class="mb-4"
              />
              <PostEvidencePart
                v-if="selectingPost"
                ref="card__part-task-list"
                :key="`card__part-${1}-task-list`"
                :post="selectingPost"
                class="mb-3"
                :learning-unit="learningUnit"
                :editable="false"
                submittable
                :visible-status-submittable="visibleStatus"
                :assessable="
                  (evidenceSubmission && evidenceSubmission.isAwarded) ||
                  evidenceSubmission.isDenied
                "
                :disabled="submitting"
                :evidence-submission="evidenceSubmission"
                @save-success="handleSaveSuccess"
                @processing="isCurrentlySavingOrUploading = $event"
              />
            </b-col>
          </b-row>
          <b-row v-if="evidenceSubmission.isNotSubmitted" class="w-100 wrapper__button-continue">
            <!-- Navigation Confirmation Modal -->
            <b-modal
              v-model="showNavigationConfirmationModal"
              title="Unsaved Changes"
              centered
              no-close-on-backdrop
              no-close-on-esc
            >
              <p>Are you sure that you want to leave without saving? All changes will be lost.</p>

              <template #modal-footer>
                <b-button variant="link" @click="leaveWithoutSave"> Leave without saving </b-button>
                <!-- <b-button variant="success" @click="saveAndContinue"> Save changes </b-button> -->
              </template>
            </b-modal>

            <ModalRevisedEvidence
              :show="showRevisedEvidenceModal"
              :post-response="revisedPostResponse || {}"
              :part-title="revisedPartTitle"
              :post-title="revisedPostTitle"
              :remaining-parts="remainingUnfinishedPosts"
              @close="showRevisedEvidenceModal = false"
              @continue="handleContinueRevised"
            />
            <!-- Incomplete Evidence Modal -->
            <ModalIncompleteEvidence
              :show.sync="showIncompleteModal"
              :incomplete-parts="incompleteParts"
              @close="showIncompleteModal = false"
            />
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { usePostExtractor } from '@/composables/usePostExtractor';
import { feedMixin } from '@/mixins/feedMixin';
import Application from '@/models/Application';
import EvidenceSubmission from '@/models/EvidenceSubmission';
import LearningUnit from '@/models/LearningUnit';
// import PostEvaluationAssessmentPart from '@/components/Post/PostEvaluationAssessmentPart';
import EvidenceSubmissionUserStatusV2 from '@/components/EvidenceSubmission/EvidenceSubmissionUserStatusV2';
import PostCertificate from '@/views/Feed/components/PostCertificate';
import ModalCongratulation from '@/views/Feed/components/ModalCongratulation';
import Credential from '@/models/Credential';
import Post from '@/models/Post';
import CatalogProjectActivity from '@/models/catalog/CatalogProjectActivity';
import { userInfoMixin } from '@/mixins';
import LearningUnitScoreDescriptionCard from '@/components/LearningUnit/LearningUnitScoreDescriptionCard';
import PostResponse from '@/models/PostResponse';
import EvidenceNavigator from './components/EvidenceNavigator.vue';
import EvidenceSidebar from './components/EvidenceSidebar.vue';
import PostEvidencePart from '@/components/Post/PostEvidencePart.vue';
import CreateNewSubmissionCard from '@/components/EvidenceSubmission/CreateNewSubmissionCard.vue';
import ModalIncompleteEvidence from './components/ModalIncompleteEvidence.vue';
import ModalRevisedEvidence from './components/ModalRevisedEvidence.vue';

import { useValidator } from '@/composables/useValidator';
const { isNotBlank } = useValidator();

export default {
  components: {
    // PostEvaluationAssessmentPart,
    EvidenceSubmissionUserStatusV2,
    PostCertificate,
    ModalCongratulation,
    LearningUnitScoreDescriptionCard,
    EvidenceNavigator,
    EvidenceSidebar,
    PostEvidencePart,
    CreateNewSubmissionCard,
    ModalRevisedEvidence,
    ModalIncompleteEvidence
  },
  mixins: [feedMixin, userInfoMixin],

  props: {
    canCreateNewSubmission: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      activeModal: false,
      saving: false,
      selectedEvidenceSubmissionId: this.$route.query.submissionId || null,
      selectedPostId: 27,
      mappedData: {},
      incompleteParts: [],
      visibleStatus: false,
      isLargeScreen: false,
      isShowNavigator: false,
      currentComponent: 'EvidenceSidebar',
      disabled: true, // This is used to disable the form when the evidence submission is in progress
      showNavigationConfirmationModal: false,
      pendingPostSelection: null,
      showRevisedEvidenceModal: false,
      revisedPostResponse: null,
      revisedPartTitle: '',
      revisedPostTitle: '',
      showIncompleteModal: false, // Set to true for testing
      isCurrentlySavingOrUploading: false,
      applyFetching: false
    };
  },

  computed: {
    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.query()
        .with('ultimate_learning_outcome')
        .whereId(this.learningUnitId)
        .first();
    },

    partMetaData() {
      return Object.keys(Post.PART).filter((part) => this.partPostIds[part]?.length > 0);
    },

    evidenceSubmission() {
      return this.selectedEvidenceSubmissionId
        ? EvidenceSubmission.find(this.selectedEvidenceSubmissionId)
        : null;
    },

    postEvaluationAssessments() {
      const posts = Post.query()
        .where('post_type', 'EVALUATION_ASSESSMENT')
        .where('learning_unit_id', this.learningUnitId)
        .get();

      return posts;
    },

    partPostIds() {
      const { extractPostIdGroupByPart } = usePostExtractor();

      const { postEvaluationAssessments = [] } = this;

      return postEvaluationAssessments.length
        ? extractPostIdGroupByPart(postEvaluationAssessments)
        : {};
    },
    selectingPost() {
      return Post.find(this.selectedPostId);
    },

    hasInvalidUploadFiles() {
      return this.evidenceSubmission ? this.evidenceSubmission.hasInvalidUploadFiles : false;
    },

    credential() {
      return Credential.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('user_id', this.userId)
        .with('user')
        .first();
    },

    postResponses() {
      return PostResponse.query()
        .where('evidence_submission_id', this.evidenceSubmission.id)
        .where('assessment_evaluation_id', null)
        .get();
    },
    selectedPostResponses() {
      return PostResponse.query()
        .where('evidence_submission_id', this.evidenceSubmission.id)
        .where('post_id', this.selectedPostId)
        .where('assessment_evaluation_id', null)
        .get();
    },
    finishedPost() {
      return this.postResponses
        .filter((postResponse) => {
          return this.isEmptyResponse(postResponse);
        })
        .map((postResponse) => postResponse.post_id);
    },
    notPassedPosts() {
      if (!this.evidenceSubmission || this.evidenceSubmission.isFirstSubmission) {
        return [];
      }
      // Get post responses with assessment evaluations
      const postResponsesWithEvaluation = PostResponse.query()
        .where('evidence_submission_id', this.evidenceSubmission.previous_evidence_submission)
        .where('assessment_evaluation_id', (value) => value !== null)
        .with('assessment_evaluation')
        .get();

      // Filter and map to post IDs where pass === false
      return postResponsesWithEvaluation
        .filter((postResponse) => postResponse.isNotPassed)
        .map((postResponse) => postResponse.post_id);
    },
    isContinueable() {
      // Check if all posts have either descriptions or attachments
      return (
        this.postResponses.every((postResponse) => {
          return this.isEmptyResponse(postResponse);
        }) &&
        !this.hasUnsavedChanges() &&
        !this.isCurrentlySavingOrUploading &&
        !this.postResponses.some((p) => p.is_editing)
      );
    },
    isShowContinueButton() {
      return (
        this.evidenceSubmission.submitted_at === null && this.evidenceSubmission.isNotSubmitted
      );
    },
    remainingUnfinishedPosts() {
      return this.postResponses.length - this.finishedPost.length;
    },

    isApplied() {
      return Application.query()
        .where((apply) => {
          return apply.user.id == this.userId && apply.learning_unit.id == this.learningUnitId;
        })
        .first();
    },

    evidenceSubmissions() {
      return EvidenceSubmission.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('user_id', this.userId)
        .get();
    },

    countRemainingSubmission() {
      if (!this.isApplied) return 0;
      const notSubmittedCount = this.evidenceSubmissions.filter(
        (submission) => submission.isNotSubmitted
      ).length;
      return this.isApplied.remaining_submission + notSubmittedCount;
    },

    countTotalSubmission() {
      if (!this.isApplied) return 0;
      const maxSubmittedNo = this.evidenceSubmissions.reduce(
        (max, submission) => Math.max(max, Number(submission.submitted_no) || 0),
        0
      );

      const projectEndedCount = this.evidenceSubmissions.filter(
        (submission) => submission.isProjectEnded
      ).length;

      return Math.max(
        0,
        this.countRemainingSubmission + (maxSubmittedNo - 1) - projectEndedCount
      );
    }
  },

  watch: {
    // "$route.path": {
    //   immediate: true,
    //   handler: "onRouteChanged",
    // },
    // selectedEvidenceSubmissionId: {
    //   handler: "onSelectedEvidenceSubmissionIdChanged",
    // }
  },

  async created() {
    await this.fetch();
    this.fetchApply();
    this.updateIsLargeScreen();
    window.addEventListener('resize', this.updateIsLargeScreen);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsLargeScreen);
  },

  methods: {
    async fetchApply() {
      if (!this.userId) return;

      try {
        this.applyFetching = true;
        await Application.api().find({
          user: this.userId,
          learning_unit: this.learningUnitId
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.applyFetching = false;
      }
    },

    async saveAllForms() {
      // Get all PostResponseForm components using refs
      const formComponents = this.getAllPostResponseFormRefs();

      const promises = formComponents.map((form) => {
        if (form.forceSaveAndDisable && typeof form.forceSaveAndDisable === 'function') {
          console.log('Calling forceSaveAndDisable on form');
          return form.forceSaveAndDisable();
        } else {
          console.log('Form does not have forceSaveAndDisable method');
        }
      });

      await Promise.all(promises.filter(Boolean));
    },

    resetAllForms() {
      // Get all PostResponseForm components using refs
      const formComponents = this.getAllPostResponseFormRefs();

      formComponents.forEach((form) => {
        if (form.forceResetEdit && typeof form.forceResetEdit === 'function') {
          console.log('Calling forceResetEdit on form');
          form.forceResetEdit();
        } else {
          console.log('Form does not have forceResetEdit method');
        }
      });
    },

    getAllPostResponseFormRefs() {
      const forms = [];

      // Get PostResponseForm components from the PostEvidencePart ref
      const postEvidencePart = this.$refs['card__part-task-list'];

      if (postEvidencePart) {
        // PostEvidencePart contains PostResponseForm components
        // Look for PostResponseForm within the PostEvidencePart component
        this.searchForPostResponseForms(postEvidencePart, forms);
      }

      return forms;
    },

    searchForPostResponseForms(component, forms) {
      // Check if current component is PostResponseForm
      if (component.$options.name === 'PostResponseForm') {
        forms.push(component);
      }

      // Check for ref 'response-form' which is commonly used for PostResponseForm
      if (component.$refs && component.$refs['response-form']) {
        forms.push(component.$refs['response-form']);
      }

      // Recursively check children
      if (component.$children) {
        component.$children.forEach((child) => {
          this.searchForPostResponseForms(child, forms);
        });
      }
    },

    // async onRouteChanged() {
    //   await this.fetch();
    // },
    toggleNavigator() {
      this.isShowNavigator = !this.isShowNavigator;
    },

    updateIsLargeScreen() {
      const viewportWidth = document.documentElement.clientWidth;
      this.isLargeScreen = viewportWidth >= 768;
    },

    onSelectedEvidenceSubmissionIdChanged(submissionId) {
      this.$router.push({
        query: {
          tab: 'submission',
          submissionId
        }
      });
    },
    onPostSelected(postId) {
      this.selectedPostId = postId;
      this.isShowNavigator = false;

      // Close the sidebar on mobile when a post is selected
      if (!this.isLargeScreen && this.$refs.evidenceSidebar) {
        this.$refs.evidenceSidebar.closeSidebar();
      }
    },

    async fetch() {
      this.loading = true;

      this.logProjectAndLearningUnitView();

      await this.fetchCredential();

      try {
        await EvidenceSubmission.api().fetchLearner(this.learningUnitId);

        if (!this.$route.query.submissionId) {
          // Don't default to a project-ended submission (denied with no
          // assessor review) — pick the latest submission the learner can act on.
          const latestEvidenceSubmission =
            EvidenceSubmission.getLatestSubmittableEvidenceSubmission(
              this.learningUnitId,
              this.userId
            );

          if (latestEvidenceSubmission) {
            this.selectedEvidenceSubmissionId = latestEvidenceSubmission.id;
          }
        }
      } catch (error) {
        this.$toast('Cannot load your submissions, please try again');
      } finally {
        setTimeout(() => {
          this.loading = false;
          this.$emit('fetch-complete');
        }, 500);
      }
    },

    // Fire-and-forget: record the learner's first view of this project/micro-credential.
    // Failures are logged but must never block the evidence submission page from loading.
    logProjectAndLearningUnitView() {
      CatalogProjectActivity.api()
        .logProjectView(this.learningUnitId)
        .catch((error) => console.error('Cannot log project view', error));

      CatalogProjectActivity.api()
        .logLearningUnitView(this.learningUnitId)
        .catch((error) => console.error('Cannot log micro-credential view', error));
    },

    async fetchCredential() {
      let promise;

      try {
        promise = await Credential.api().fetch(this.learningUnitId, this.userId);
      } catch (error) {
        this.$toast.error('Cannot load credential');
      }

      return promise;
    },

    async onSaveAllPostDescriptions() {
      //กด save description ของ post ทุกๆตัวในทุกๆ part
      const tasks = this.$refs['card__part-task-list'];

      for (let i = 0; i < tasks.length; i++) {
        const posts = tasks[i].$refs['card__part-post-list'];

        if (posts && posts.length) {
          for (let j = 0; j < posts.length; j++) {
            let response = posts[j].$refs['response-form'];

            if (response && response.saveDescriptionNoTimeOut) {
              await response.saveDescriptionNoTimeOut();
            } else {
              this.$toast.error('Something went wrong, please try again');
            }
          }
        }
      }
    },

    async getPostDescriptionsStatus() {
      // check ว่า post ในแต่ละ part มี description หรือไม่ จาก vuex
      const posts = this.postResponses;
      console.log('ois ', posts);

      const result = posts.reduce((acc, response) => {
        acc[response.post_id] = !!(
          isNotBlank(response.description) && response.save_message === 'Saved'
        );
        return acc;
      }, {});

      return result;
    },

    async getComparisonPostsResponse() {
      // check ว่า post ในแต่ละ part มี description หรือไม่ จาก backend
      const posts = this.postResponses.map((response) => ({
        id: response.post_id,
        post_response_id: response.id,
        description: response.description,
        attachments: response.attachments.map((attachment) => attachment.id)
      }));

      try {
        const {
          response: { data }
        } = await PostResponse.api().comparisonResponses({ posts });

        return data;
      } catch (error) {
        console.error('Error during comparison process:', error);
      }
    },

    async onContinue() {
      this.saving = true;

      try {
        // from backend
        const responses = await this.getComparisonPostsResponse();

        await this.mapResponsesToIncompleteParts(responses);

        this.visibleStatus = true;

        if (!this.incompleteParts.length) {
          this.$router.push({ name: 'learning-unit/preview' });
        }
      } catch (error) {
        console.error('Error during save process:', error);
        this.$toast.error('Connection failed');
      } finally {
        this.saving = false;
      }
    },

    async mapResponsesToIncompleteParts(responses) {
      const partIds = this.partPostIds;

      const postResponses = responses;

      for (const key in partIds) {
        this.mappedData[key] = partIds[key].map((value) => postResponses[value]);
      }

      let comparisonPartValue = [];

      for (const i in this.mappedData) {
        for (const j in this.mappedData[i]) {
          if (this.mappedData[i][j] === false) {
            this.showIncompleteModal = true;

            comparisonPartValue.push({
              part: i
            });
          }
        }
      }

      let comparisonPart = comparisonPartValue.filter((item, index, self) => {
        return index === self.findIndex((t) => t.part === item.part);
      });

      const partMapping = {
        OVERVIEW: 'Part 1 : Overview',
        WORK_EXAMPLE: 'Part 2 : Work Example',
        REFLECTION: 'Part 3 : Reflection'
      };

      this.incompleteParts = comparisonPart.map((item) => {
        return {
          part: partMapping[item.part]
        };
      });
    },

    scrollToPart(part) {
      const partMapping = {
        'Part 1 : Overview': 0,
        'Part 2 : Work Example': 1,
        'Part 3 : Reflection': 2
      };

      this.$nextTick(() => {
        setTimeout(() => {
          const index = partMapping[part];
          if (index !== undefined && this.$refs['card__part-task-list'][index]) {
            this.$refs['card__part-task-list'][index].$el.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }, 300);
        this.activeModal = false;
      });
    },
    backToMethodComponents() {
      this.$router.push({
        name: 'learning-unit/method-components'
      });
      this.$emit('back-to-method-components');
    },

    onNavigationChangeItem(postId) {
      if (this.isCurrentlySavingOrUploading) {
        if (!this._navigationToastTimeout) {
          this.$toast.info('Please wait until saving or uploading is complete.');
          this._navigationToastTimeout = setTimeout(() => {
            this._navigationToastTimeout = null;
          }, 3000);
        }
        return;
      }

      // Check if any forms are currently being edited using Vue refs
      if (this.hasUnsavedChanges()) {
        this.pendingPostSelection = postId;
        this.showNavigationConfirmationModal = true;
        return;
      }

      // If no unsaved changes, proceed with navigation
      this.onPostSelected(postId);
    },

    hasUnsavedChanges() {
      // Use Vue refs to check for unsaved changes instead of DOM traversal
      const formComponents = this.getAllPostResponseFormRefs();
      console.log('Found form components:', formComponents.length);

      const hasChanges = formComponents.some((form) => {
        // First check if the form has its own hasUnsavedChanges method
        if (form.hasUnsavedChanges && typeof form.hasUnsavedChanges === 'function') {
          const formHasChanges = form.hasUnsavedChanges();
          console.log(
            'Form has unsaved changes (via method):',
            formHasChanges,
            'Component name:',
            form.$options.name
          );
          return formHasChanges;
        }

        // Fallback to checking data-editing attribute
        const isEditing = form.$el && form.$el.getAttribute('data-editing') === 'true';
        console.log(
          'Form isEditing (via attribute):',
          isEditing,
          'Component name:',
          form.$options.name
        );
        return isEditing;
      });

      console.log('Has unsaved changes:', hasChanges);
      return hasChanges;
    },

    async saveAndContinue() {
      // Save all forms using Vue refs
      await this.saveAllForms();

      // Wait a moment for save operations to complete
      setTimeout(() => {
        if (this.pendingPostSelection !== null) {
          // Call the navigator to execute the pending navigation
          const navigator = this.$refs.evidenceNavigator || this.$refs.evidenceNavigatorLarge;
          if (navigator && navigator.executePendingNavigation) {
            navigator.executePendingNavigation(this.pendingPostSelection);
          } else {
            this.onPostSelected(this.pendingPostSelection);
          }
        }
        this.showNavigationConfirmationModal = false;
        this.pendingPostSelection = null;
      }, 500);
    },

    leaveWithoutSave() {
      // Reset all forms using Vue refs
      this.resetAllForms();

      if (this.pendingPostSelection !== null) {
        // Call the navigator to execute the pending navigation
        const navigator = this.$refs.evidenceNavigator || this.$refs.evidenceNavigatorLarge;
        if (navigator && navigator.executePendingNavigation) {
          navigator.executePendingNavigation(this.pendingPostSelection);
        } else {
          this.onPostSelected(this.pendingPostSelection);
        }
      }
      this.showNavigationConfirmationModal = false;
      this.pendingPostSelection = null;
    },

    // Handle submission created event from CreateNewSubmissionButton component
    async onSubmissionCreated() {
      // Force refresh the page data to ensure all components are updated
      await this.fetch();
    },

    handleSaveSuccess(postResponse) {
      // Check if this is a resubmission (submitted_no > 1 or has previous submission)
      const isResubmission = !this.evidenceSubmission.isFirstSubmission;

      if (isResubmission) {
        this.revisedPostResponse = postResponse;

        // Find part and post titles
        const post = Post.find(postResponse.post_id);
        if (post) {
          this.revisedPostTitle = post.title;
          this.revisedPartTitle = this.partMetaData.find((part) =>
            this.partPostIds[part].includes(post.id)
          );
          // Format part title if needed, similar to EvidenceNavigator
          const partMapping = {
            OVERVIEW: 'Part 1 : Overview',
            WORK_EXAMPLE: 'Part 2 : Work Example',
            REFLECTION: 'Part 3 : Reflection'
          };
          this.revisedPartTitle = partMapping[this.revisedPartTitle] || this.revisedPartTitle;
        }

        this.showRevisedEvidenceModal = true;
      }
    },

    handleContinueRevised() {
      this.showRevisedEvidenceModal = false;

      // 1. Get all Post IDs in the correct visual order
      const sortedParts = ['OVERVIEW', 'WORK_EXAMPLE', 'REFLECTION'];
      const orderedPostIds = [];

      sortedParts.forEach((part) => {
        if (this.partPostIds[part]) {
          orderedPostIds.push(...this.partPostIds[part]);
        }
      });

      const currentPostId = this.revisedPostResponse.post_id;
      const currentIndex = orderedPostIds.indexOf(currentPostId);

      if (currentIndex === -1) return;

      // Helper to check if a post is unfinished
      const isUnfinished = (postId) => {
        // Find the response for this post ID
        const response = this.postResponses.find((r) => r.post_id === postId);

        // If no response found, it might mean it's not started or just missing data.
        // Assuming if it's in orderedPostIds (which comes from Post model), it should have a response if initialized.
        // But if response is missing, treat as unfinished.
        if (!response) return true;

        return !this.isEmptyResponse(response);
      };

      let nextIndex = -1;

      // 1. Search forward from current + 1
      for (let i = currentIndex + 1; i < orderedPostIds.length; i++) {
        if (isUnfinished(orderedPostIds[i])) {
          nextIndex = i;
          break;
        }
      }

      // 2. If not found, wrap around and search from 0 to current
      if (nextIndex === -1) {
        for (let i = 0; i < currentIndex; i++) {
          if (isUnfinished(orderedPostIds[i])) {
            nextIndex = i;
            break;
          }
        }
      }

      // 3. If still not found (all finished), just go to next sequential post
      if (nextIndex === -1) {
        if (currentIndex < orderedPostIds.length - 1) {
          nextIndex = currentIndex + 1;
        } else if (orderedPostIds.length > 1) {
          // If at the very end and everything is finished, wrap to start
          nextIndex = 0;
        }
      }

      if (nextIndex !== -1) {
        const nextPostId = orderedPostIds[nextIndex];
        // Use the navigator to change item to ensure consistency
        const navigator = this.$refs.evidenceNavigator || this.$refs.evidenceNavigatorLarge;
        if (navigator) {
          // We need to bypass unsaved check here because we just saved
          // TODO: someting here
          this.onPostSelected(nextPostId);
        } else {
          this.onPostSelected(nextPostId);
        }
      }
    },
    isEmptyResponse(postResponse) {
      // Check if has description
      const hasDescription = postResponse.description;

      // Check if has attachments
      const hasAttachments = postResponse.attachments && postResponse.attachments.length > 0;

      // Return true if has either description OR attachments
      return hasDescription || hasAttachments;
    }
  }
};
</script>

<style lang="scss" scoped>
.custome-text-muted {
  color: #7a7b97;
  font-size: 16px;
  line-height: 1.5;
}
@media screen and (max-width: 992px) {
  .container {
    max-width: 100%;
  }
}

.text__feedback-for-earner {
  img {
    max-width: -moz-available; /* WebKit-based browsers will ignore this. */
    max-width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */
  }
}

.wrapper__button-continue {
  max-width: 910px;
  margin: auto;
  background-color: red;
}

.container__submit-evidence {
  display: flex;
  flex-direction: column;
  justify-items: center;
}
.sticky {
  position: sticky;
  top: 20px;
}

.navigator.mobile-navigator {
  margin-top: 8px;
  margin-left: 20px;
  width: 269px;
  border: 1px solid #e9ecef;

  position: absolute;
  top: auto;
  z-index: 10;
}
@media screen and (min-width: 376px) {
  .navigator.mobile-navigator {
    width: 307px;
  }
}

::v-deep img.max-w-full,
::v-deep figure img {
  width: 100%;
  height: auto;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  width: 100%;
}
</style>
